import { MenuItem } from '@/models/sidebar';

export const settingsOverviewItem: MenuItem = {
  id: 'settings-overview',
  name: 'Overview',
  path: '/settings',
  icon: 'SquaresFour',
};

export const settingsWorkspaceItems: MenuItem[] = [
  {
    id: 'settings-users-roles',
    name: 'Users & roles',
    path: '/identity-management',
    icon: 'UsersThree',
  },
  {
    id: 'settings-custom-fields',
    name: 'Custom fields',
    path: '/custom-fields',
    icon: 'SlidersHorizontal',
  },
];

export const settingsSendingItems: MenuItem[] = [
  {
    id: 'settings-opt-in',
    name: 'Double opt-in',
    path: '/settings/opt-in',
    icon: 'FileText',
  },
  {
    id: 'settings-system-emails',
    name: 'System emails',
    path: '/settings/system-emails',
    icon: 'PaperPlaneTilt',
  },
];

export const settingsComplianceItems: MenuItem[] = [
  {
    id: 'settings-branding',
    name: 'Branding',
    path: '/settings/branding',
    icon: 'ImageSquare',
  },
  {
    id: 'settings-legal-footer',
    name: 'Legal footer',
    path: '/settings/legal-footer',
    icon: 'FileText',
  },
  {
    id: 'settings-audit-log',
    name: 'Audit log',
    path: '/audit-log',
    icon: 'ClipboardText',
  },
];

export const settingsDeveloperItems: MenuItem[] = [
  {
    id: 'settings-api-keys',
    name: 'API keys',
    path: '/api-keys',
    icon: 'Key',
  },
];

export const SETTINGS_SECTION_PATH_PREFIXES = [
  '/settings',
  '/identity-management',
  '/custom-fields',
  '/api-keys',
  '/audit-log',
];

export const isSettingsSectionPath = (pathname: string) =>
  SETTINGS_SECTION_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
